import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LayoutComponent} from './layout.component';
import {LoginComponent} from './login/login.component';
import {CampaignConfigModule} from './campaign-config/campaign-config.module';
import {AuthGuard} from './auth/auth.guard';
import {DjContestGuard} from './auth/dj-contest.guard';
import {SuperAdminGuard} from './auth/super-admin.guard';
import {DatetimeTestComponent} from './datetime-test/datetime-test.component';

const adminRoutes: Routes = [
  {
    path: 'admin/login',
    component: LoginComponent,
  },
  {
    path: 'admin',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'datetime-test',
        data: {title: 'Datetime picker v2 test'},
        component: DatetimeTestComponent,
      },
      {
        path: 'events/verified-events',
        data: {title: 'Verified Events'},
        loadChildren: () => import('./events/verified-events/verified-events.module').then(m => m.VerifiedEventsModule),
      },
      {
        path: 'events',
        data: {title: 'Events'},
        loadChildren: () => import('./events/events.module').then(m => m.EventsModule),
      },
      {
        path: 'event-groups',
        data: {title: 'Event groups'},
        loadChildren: () => import('./event-groups-list/event-groups-list.module').then(m => m.EventGroupsListModule),
      },
      {
        path: 'tasks',
        data: {title: 'Tasks'},
        loadChildren: () => import('./task-management/task-management.module').then(m => m.TaskManagementModule),
      },
      {
        path: 'campaign_overview',
        data: {title: 'Campaign overview'},
        loadChildren: () => import('./campaign-overview/campaign-overview.module').then(m => m.CampaignOverviewModule),
      },
      {
        path: 'sales',
        data: {title: 'Sales'},
        loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule),
      },
      {
        path: 'orders',
        data: {title: 'Orders'},
        loadChildren: () => import('./orders/orders.module').then(m => m.OrdersModule),
      },
      {
        path: 'invoicing',
        data: {title: 'Invoicing'},
        loadChildren: () => import('./invoicing/invoicing.module').then(m => m.InvoicingModule),
      },
      {
        path: 'curated-lists',
        data: {title: 'Curated Lists'},
        loadChildren: () => import('./curated-lists/curated-lists.module').then(m => m.CuratedListsModule),
      },
      {
        path: 'recommender-debug',
        data: {title: 'Recommender Debug'},
        loadChildren: () => import('./recommender-debug/recommender-debug.module').then(m => m.RecommenderDebugModule),
      },
      {
        path: 'most-popular-debug',
        data: {title: 'Most popular wingame debug'},
        loadChildren: () =>
          import('./most-popular-debug/most-popular-debug.module').then(m => m.MostPopularDebugModule),
      },
      {
        path: 'kpi-overview',
        data: {title: 'KPI'},
        loadChildren: () => import('./kpi-overview/kpi-overview.module').then(m => m.KpiOverviewModule),
      },
      {
        path: 'emails',
        data: {title: 'Emails'},
        loadChildren: () => import('./emails/emails.module').then(m => m.EmailsModule),
      },
      {
        path: 'wingames',
        data: {title: 'Win Games'},
        loadChildren: () => import('./wingames/wingames.module').then(m => m.WingamesModule),
      },
      {
        path: 'discover',
        data: {title: 'Discover page'},
        loadChildren: () => import('./discover/discover.module').then(m => m.DiscoverModule),
      },
      // {
      //   path: 'shop',
      //   data: {title: 'Shop'},
      //   loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule),
      // },
      {
        path: 'companies',
        data: {title: 'Companies'},
        loadChildren: () => import('./companies/companies.module').then(m => m.CompaniesModule),
      },
      {
        path: 'companies-reports',
        data: {title: 'Companies Reports'},
        loadChildren: () => import('./companies-reports/companies-reports.module').then(m => m.CompaniesReportsModule),
      },
      {
        path: 'users-reports',
        data: {title: 'User Reports'},
        loadChildren: () => import('./users-reports/users-reports.module').then(m => m.UsersReportsModule),
      },
      {
        path: 'users-management',
        data: {title: 'User Reports'},
        loadChildren: () => import('./users-management/users-management.module').then(m => m.UsersManagementModule),
      },
      {
        path: 'cancelled-events-export',
        loadChildren: () =>
          import('./cancelled-events-export/cancelled-events-export.module').then(m => m.CancelledEventsExportModule),
      },
      {
        path: 'pages',
        data: {title: 'Pages'},
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
      },
      {
        path: 'posts',
        data: {title: 'Posts'},
        loadChildren: () => import('./posts/posts.module').then(m => m.PostsModule),
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'kpi-overview',
      },
      {
        path: 'categories',
        data: {title: 'Categories'},
        loadChildren: () => import('./categories/categories.module').then(m => m.CategoriesModule),
      },
      {
        path: 'merge-events',
        data: {title: 'Merge Events'},
        loadChildren: () => import('./merge-events/merge-events.module').then(m => m.MergeEventsModule),
      },
      {
        path: 'ticket-migration',
        data: {title: 'Ticket Migration'},
        loadChildren: () => import('./ticket-migration/ticket-migration.module').then(m => m.TicketMigrationModule),
      },
      {
        path: 'notifications',
        data: {title: 'Notifications'},
        loadChildren: () => import('./notifications/notifications.module').then(m => m.NotificationsModule),
      },
      {
        path: 'event-configuration',
        data: {title: 'Event configuration'},
        loadChildren: () =>
          import('./event-configuration/event-configuration.module').then(m => m.EventConfigurationModule),
      },
      {
        path: 'genral-sharinglink',
        data: {title: 'General sharing links'},
        loadChildren: () =>
          import('./general-sharinglinks/general-sharinglinks.module').then(m => m.GeneralSharinglinksModule),
      },
      {
        path: 'shop',
        data: {title: 'Shop'},
        loadChildren: () => import('./shop/shop.module').then(m => m.ShopModule),
      },
      {
        path: 'loyalty',
        data: {title: 'Loyalty'},
        loadChildren: () => import('./loyalty/loyalty.module').then(m => m.LoyaltyModule),
      },
      {
        path: 'user-tickets',
        data: {title: 'User tickets'},
        loadChildren: () => import('./user-tickets/user-tickets.module').then(m => m.UserTicketsModule),
      },
      {
        path: 'custom-audience-group',
        data: {title: 'Custom audience group'},
        loadChildren: () =>
          import('./custom-audience-group/custom-audience-group.module').then(m => m.CustomAudienceGroupModule),
      },
      {
        path: 'venues',
        data: {title: 'Venues'},
        loadChildren: () => import('./venues/venues.module').then(m => m.VenuesModule),
      },
      {
        path: 'referral-codes-frauds',
        data: {title: 'Referral codes frauds'},
        loadChildren: () =>
          import('./referral-codes-frauds/referral-codes-frauds.module').then(m => m.ReferralCodesFraudsModule),
      },
      {
        path: 'artists',
        data: {title: 'Artists'},
        loadChildren: () => import('./artists/artists.module').then(m => m.ArtistsModule),
      },
      {
        path: 'campaign-config',
        data: {title: 'Campaign config'},
        loadChildren: () => import('./campaign-config/campaign-config.module').then(m => m.CampaignConfigModule),
      },
      {
        path: 'cash-based-revenue',
        data: {title: 'AM & BDM dashboard'},
        loadChildren: () =>
          import('./cash-based-revenue/cash-based-revenue.module').then(m => m.CashBasedRevenueModule),
      },
      {
        path: 'admin-roles',
        data: {title: 'Admin roles management'},
        canActivate: [SuperAdminGuard],
        loadChildren: () =>
          import('./admin-roles-management/admin-roles.module').then(m => m.AdminRoleConfigurationModule),
      },
      {
        path: 'vouchers',
        loadChildren: () => import('./shop-vouchers/shop-vouchers.module').then(m => m.ShopVouchersModule),
      },
      {
        path: 'translations',
        data: {title: 'Translations'},
        canActivate: [SuperAdminGuard],
        loadChildren: () => import('./translations/translations.module').then(m => m.TranslationsModule),
      },
      {
        path: 'the-drop',
        data: {title: 'The Drop'},
        canActivate: [DjContestGuard],
        loadChildren: () => import('./the-drop/the-drop.module').then(m => m.TheDropModule),
      },
      {
        path: 'google-identities',
        data: {title: 'Google logins'},
        canActivate: [SuperAdminGuard],
        loadChildren: () =>
          import('./google-identities/google-identities.module').then(m => m.GoogleIdentitiesModule),
      },
      {
        path: 'login-audit',
        data: {title: 'Login audit log'},
        canActivate: [SuperAdminGuard],
        loadChildren: () => import('./login-audit/login-audit.module').then(m => m.LoginAuditModule),
      },
      {
        path: 'facebook-event-import',
        data: {title: 'PartyFlock'},
        loadChildren: () =>
          import('./facebook-event-import/facebook-event-import.module').then(m => m.FacebookEventImportModule),
      },
      {
        path: 'photos-uploader',
        data: {title: 'Photos uploader'},
        loadChildren: () => import('./photos-uploader/photos-uploader.module').then(m => m.PhotosUploaderModule),
      },
      {
        path: 'dynamic-lists',
        data: {title: 'Dynamic lists management'},
        canActivate: [SuperAdminGuard],
        loadChildren: () =>
          import('./dynamic-lists-management/dynamic-lists-management.module').then(
            m => m.DynamicListsManagementModule,
          ),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(adminRoutes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
